import { Autocomplete, Box, Paper, TextField, ThemeProvider, createTheme, useTheme } from '@mui/material';
import { DiscoverTvStatus } from '@tmdb-graphql-api/schema/types';
import { type FormikErrors } from 'formik';
import { type TvFormikValues } from '../types.ts';

export type TvStatusMultiSelectDropdownProps = {
  ariaLabelledBy: string;
  name: string;
  setFieldValue: (
    field: string,
    value: any, // eslint-disable-line @typescript-eslint/no-explicit-any
    shouldValidate?: boolean,
  ) => Promise<FormikErrors<TvFormikValues>> | Promise<void>;
  value: { id: DiscoverTvStatus; name: string }[];
};

export const tvStatusOptions = [
  {
    id: DiscoverTvStatus.Canceled,
    name: 'Canceled',
  },
  {
    id: DiscoverTvStatus.Ended,
    name: 'Ended',
  },
  {
    id: DiscoverTvStatus.InProduction,
    name: 'In Production',
  },
  {
    id: DiscoverTvStatus.Pilot,
    name: 'Pilot',
  },
  {
    id: DiscoverTvStatus.Planned,
    name: 'Planned',
  },
  {
    id: DiscoverTvStatus.ReturningSeries,
    name: 'Returning Series',
  },
];

export const TvStatusMultiSelectDropdown = ({
  ariaLabelledBy,
  name,
  setFieldValue,
  value,
}: TvStatusMultiSelectDropdownProps) => {
  const theme = useTheme();

  return (
    <ThemeProvider theme={createTheme({ ...theme, palette: { mode: 'dark' } })}>
      <Autocomplete
        aria-labelledby={ariaLabelledBy}
        autoComplete
        clearIcon=""
        filterSelectedOptions
        getOptionLabel={option => option.name}
        includeInputInList
        multiple
        noOptionsText=""
        onChange={(_e, option) => {
          void setFieldValue(name, option);
        }}
        options={tvStatusOptions}
        renderInput={params => <TextField {...params} fullWidth hiddenLabel placeholder="Enter name" />}
        renderOption={(props, renderOpts) => (
          <Box component="li" {...props} key={renderOpts.id}>
            {renderOpts.name}
          </Box>
        )}
        slots={{
          paper: params => <Paper {...params} sx={{ backgroundColor: '#222' }} />,
        }}
        value={value}
      />
    </ThemeProvider>
  );
};
